"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translate2d = void 0;
var interpolate = function (x, src_x1, src_x2, dest_x1, dest_x2) {
    if (src_x1 === src_x2 && src_x2 === x) {
        return ((dest_x2 - dest_x1) / 2) + dest_x1;
    }
    return ((x - src_x1) / (src_x2 - src_x1)) * (dest_x2 - dest_x1) + dest_x1;
};
var translate2d = function (coord, srcPlane, destPlane) {
    var _a = [srcPlane[0][0][0], srcPlane[0][1][0]], src_x1 = _a[0], src_x2 = _a[1];
    var _b = [srcPlane[1][0][1], srcPlane[1][1][1]], src_y1 = _b[0], src_y2 = _b[1];
    var _c = [destPlane[0][0][0], destPlane[0][1][0]], dest_x1 = _c[0], dest_x2 = _c[1];
    var _d = [destPlane[1][0][1], destPlane[1][1][1]], dest_y1 = _d[0], dest_y2 = _d[1];
    var x = coord[0];
    var y = coord[1];
    return [
        interpolate(x, src_x1, src_x2, dest_x1, dest_x2),
        interpolate(y, src_y1, src_y2, dest_y1, dest_y2),
    ];
};
exports.translate2d = translate2d;
